import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux' 
import UserSliceReducer from '../../app/modules/auth/redux/AuthSlice'
import CustomerListSliceReducer from '../../app/modules/searchShowCustomer/redux/CustomerListSlice'
import CustomerDetailSliceReducer from '../../app/modules/searchShowCustomer/redux/CustomerDetailSlice'
import storeListSliceReducer from '../../app/pages/product/redux/StoreSlice'
import currentStoreSliceReducer from '../../app/pages/product/redux/CurrentStoreSlice'
import productListSliceReducer from '../../app/pages/product/redux/ProductListSlice'
import productDetailSliceReducer from '../../app/pages/product/redux/ProductDetailSlice'
import * as auth from '../../app/modules/auth'


export const rootReducer = combineReducers({
  auth: auth.reducer, 
  userReducer:UserSliceReducer,
  customerListReducer:CustomerListSliceReducer,
  customerDetailReducer:CustomerDetailSliceReducer,
  storeListReducer:storeListSliceReducer,
  currentStoreReducer:currentStoreSliceReducer,
  productListReducer:productListSliceReducer,
  productDetailReducer:productDetailSliceReducer

})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}



